import { render, staticRenderFns } from "./Tool.vue?vue&type=template&id=0984f2cd&scoped=true"
import script from "./Tool.vue?vue&type=script&lang=js"
export * from "./Tool.vue?vue&type=script&lang=js"
import style0 from "./Tool.vue?vue&type=style&index=0&id=0984f2cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0984f2cd",
  null
  
)

export default component.exports